export default __webpack_public_path__ + "static/media/medical.bc93b827.svg";